<template>
  <div>
    <v-toolbar card color="white">
      <v-toolbar-title>Cases</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn round outline color="success" dark @click="isShowQuickDispatch = true">Điều phối nhanh</v-btn>
      <div style="width: 300px" class="my-2 mr-2"> 
        <v-text-field
          solo
          hide-details
          prepend-inner-icon="search"
          placeholder="Tìm trên danh sách này"
          v-model="keyword"
        ></v-text-field>
      </div>
      <v-combobox 
        solo 
        v-model="selectedStatus" 
        item-text="label" 
        item-value="value" 
        :items="optionsStatus" 
        label="Trạng Thái"
        style="max-width:250px"
        class="mt-2"
      > 
      </v-combobox>
      <v-menu :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            dark
            v-on="on"
            class="my-0 mr-0"
          >
            Công cụ
            <v-icon class="ml-2" size="24">expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="openDialogSendDispatchCase">
            <v-list-tile-content>
              <v-list-tile-title>Gửi Case Tới Kỹ Thuật</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon color="primary">swap_horiz</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile @click="openDialogExportTickets()">
            <v-list-tile-content>
              <v-list-tile-title>Xuất DS Case theo Kỹ thuật</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon color="green">save_alt</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      item-key="id"
      :headers="table.headers"
      :items="datasourceFiltered"
      :rows-per-page-items="[20,50,100]"
      :loading="isLoading"
    >
      <template slot="items" slot-scope="props">
        <tr class="table-row" @click="viewMore(props.item)">
          <td :class="{'red white--text': !props.item.Location}" :title="!props.item.Location ? 'Thiếu vị trí!' : null">{{ props.item.TicketCode }}</td>
          <td>{{ props.item.AccountName }}</td>
          <td>{{ props.item.Vehicle }}</td>
          <td class="no-wrap">{{ truncate(props.item.WorkLog) }}</td>
          <td class="no-wrap" :class="{'green--text text--darken-2': checkToday(props.item.Plan)}">{{ props.item.Plan }}</td>
          <td class="no-wrap">{{ props.item.CreatedBy }}</td>
          <td class="no-wrap">
            {{ props.item.AssignedTo }}
          </td>
          <td class="no-wrap">{{ props.item.RepairPerson }}</td>
          <td class="no-wrap">{{ props.item.Status }}</td>
          <td class="no-wrap">{{ props.item.Created }}</td>
        </tr>
      </template>
    </v-data-table>

    <!-- Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="isShowWorkLog" max-width="1024" content-class="case-detail">
        <!-- <case-detail :Case="selectedCase" @display="isShowWorkLog = $event" /> -->
        <ticket-detail :ticket="selectedCase" @display="isShowWorkLog = $event" />
      </v-dialog>
      <v-dialog v-model="isShowQuickDispatch" max-width="360">
        <quick-dispatch @display="isShowQuickDispatch = $event" />
      </v-dialog>
    </div>
    <!-- End Dialog -->

    <dialog-ticket-not-assign ref="dialogTicketNotAssign" />
    <dialog-export-tickets ref="dialogExportTickets"/>
  </div>
</template>

<script>
import validate from '@/utils/validate';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TicketDetail from '@/components/crm/TicketDetail';
import DialogConfirm from '@/components/DialogConfirm';
import Overview from '../Overview';
import { formatGMTToLocalTime } from '@/utils/datetime';
import QuickDispatch from './QuickDispatch';
import moment from 'moment';
import DialogTicketNotAssign from './DialogTicketNotAssign.vue';
import DialogExportTickets from './DialogExportTickets.vue';

export default {
  components: {
    // CaseDetail,
    Overview,
    QuickDispatch,
    TicketDetail,
    DialogConfirm,
    DialogTicketNotAssign,
    DialogExportTickets 
  },
  props: {
    datasource: Array,
    isLoading: Boolean
  },
  data () {
    return {
      table: {
        headers: [
          {
            text: 'CaseNumber',
            value: 'CaseNumber'
          },
          {
            text: 'AccountName',
            value: 'AccountName'
          },
          {
            text: 'Vehicle',
            value: 'Vehicle'
          },
          {
            text: 'WorkLog',
            value: 'WorkLog'
          },
          {
            text: 'Plan',
            value: 'Plan'
          },
          {
            text: 'CreatedBy',
            value: 'CreatedBy'
          },
          {
            text: 'Assigned',
            value: 'AssignedTo'
          },
          {
            text: 'RepairPerson',
            value: 'RepairPerson'
          },
          {
            text: 'Status',
            value: 'Status'
          },
          {
            text: 'Created',
            value: 'Created'
          }
        ]
      },
      datasourceFiltered: [],
      keyword: '',
      selectedCase: {},
      isShowWorkLog: false,
      isShowQuickDispatch: false,
      optionsStatus: [
        {
          label: 'Chưa được điều phối (mới)',
          value: 'New'
        },
        {
          label: 'Đã đc gửi đến kỹ thuật', 
          value: 2
        },
        {
          label: 'Đã có kỹ thuật nhận case', 
          value: 3
        },
        {
          label: 'Kỹ thuật từ chối nhận case',
          value: 4
        },
      ],
      selectedStatus: null
    };
  },
  computed: {
    ...mapGetters(['supporters'])
  },
  watch: {
    datasource () {
      this.search();
    },
    keyword () {
      localStorage.setItem('crmSearchKeyword', this.keyword);
      this.search();
    }
  },
  created () {
    this.keyword = localStorage.getItem('crmSearchKeyword') || '';
    this.search();
  },
  methods: {
    formatGMTToLocalTime,
    ...mapMutations(['SET_SELECTED_CASES']),
    ...mapActions(['ReturnTicket', 'GetAllTicket']),
    search () {
      let keywordRemovedVietnamese = validate.transferVietnamese(
        this.keyword.toLowerCase()
      );
      this.datasourceFiltered = this.datasource
        .filter(a =>
          validate
            .transferVietnamese(
              (
                a.Vehicle +
                a.TicketCode +
                a.TrackingID +
                a.WorkLog +
                a.Plan +
                a.Finished +
                a.RepairPerson +
                a.Status +
                a.AssignedTo
              ).toLowerCase()
            )
            .includes(keywordRemovedVietnamese.toLowerCase())
        )
        .reverse();
    },
    truncate (text) {
      return text.substring(0, 30) + '...';
    },
    viewMore (c) {
      this.selectedCase = c;
      this.isShowWorkLog = true;
    },
    dispatch (c) {
      this.selectedCase = c;
      this.SET_SELECTED_CASES(c);
    },

    checkToday (val) {
      let today = moment().format('YYYY-MM-DD');
      let date = moment(val).format('YYYY-MM-DD');
      return moment(date).diff(today, 'days') === 0;
    },

    async getGroup () {
      let res = await this.GetUserGroup().catch(_ => {
        return [];
      });

      this.group = [{ Id: null, Name: 'Tất cả' }, ...res] || [];
      // console.log('🚀 ~ file: Tasks.vue ~ line 204 ~ getGroup ~ res', res);
      
    },

    openDialogSendDispatchCase () {
      this.$refs.dialogTicketNotAssign.open();
    },

    openDialogExportTickets () {
      this.$refs.dialogExportTickets.open();
    }
  }
};
</script>

<style>
.no-wrap {
  white-space: nowrap;
}
.table-row {
  cursor: pointer !important;
}
.case-detail.v-dialog{
  max-height: 80% !important;
}
</style>
<style scoped>
.v-btn.btn-remove{
  height: 24px;
  width: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dispatch/components/Cases.vue